/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GlobalOptOut
 */
export interface GlobalOptOut {
    /**
     * Channel
     * @type {string}
     * @memberof GlobalOptOut
     */
    channel: string;
    /**
     * Created at
     * @type {Date}
     * @memberof GlobalOptOut
     */
    createdAt: Date;
    /**
     * Endpoint
     * @type {GlobalOptOutEndpointEnum}
     * @memberof GlobalOptOut
     */
    endpoint: GlobalOptOutEndpointEnum;
}


/**
 * @export
 */
export const GlobalOptOutEndpointEnum = {
    Email: 'email',
    Sms: 'sms'
} as const;
export type GlobalOptOutEndpointEnum = typeof GlobalOptOutEndpointEnum[keyof typeof GlobalOptOutEndpointEnum];


/**
 * Check if a given object implements the GlobalOptOut interface.
 */
export function instanceOfGlobalOptOut(value: object): value is GlobalOptOut {
    if (!('channel' in value) || value['channel'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('endpoint' in value) || value['endpoint'] === undefined) return false;
    return true;
}

export function GlobalOptOutFromJSON(json: any): GlobalOptOut {
    return GlobalOptOutFromJSONTyped(json, false);
}

export function GlobalOptOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalOptOut {
    if (json == null) {
        return json;
    }
    return {
        
        'channel': json['channel'],
        'createdAt': (new Date(json['created_at'])),
        'endpoint': json['endpoint'],
    };
}

export function GlobalOptOutToJSON(json: any): GlobalOptOut {
    return GlobalOptOutToJSONTyped(json, false);
}

export function GlobalOptOutToJSONTyped(value?: GlobalOptOut | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'channel': value['channel'],
        'created_at': value['createdAt'].toISOString(),
        'endpoint': value['endpoint'],
    };
}

